module.exports = __webpack_public_path__ + "img/img9.a0d7907a.jpg";